// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.preferences_dashboard__tSBy1 {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 35px 35px;
  border-radius: 0px;
  min-height: auto !important;
  background-color: #f5f6fa;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.preferences_dashboardContain__bDkZ5 {
  width: calc(100% - 320px);
  background-color: #f5f6fa;
  border-radius: 8px;
}

.preferences_bodythemedark__np6Ve .preferences_dashboardContain__bDkZ5,
.preferences_bodythemedark__np6Ve .preferences_dashboard__tSBy1,
.preferences_bodythemedark__np6Ve .preferences_cont2__depn9 {
  background-color: #0f1824;
}

.preferences_top_header__l7aPN .preferences_top_header_inner__Dth2I {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.preferences_cont2__depn9 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #f5f6fa;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.preferences_subLink__khKDa svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.preferences_footer__r04q2 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.preferences_bodythemelight__tHR-R {
  background-color: #fff;
  padding-top: 90px;
}

.preferences_bodythemedark__np6Ve {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.preferences_headerthemelight__Hco8q {
  background-color: #fff;
}

.preferences_headerthemedark__EFH3X {
  background-color: #132337;
}

.preferences_top_header__l7aPN {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.preferences_menuthemelight__FTSff {
  background-color: #fff;
}

.preferences_menuthemedark__Qijid {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.preferences_menulinklight__3Lqd7 span {
  color: #666666 !important;
}

.preferences_menulinklight__3Lqd7 a {
  color: #cbcbcb !important;
}

.preferences_menulinklight__3Lqd7:hover span,
.preferences_menulinklight__3Lqd7:hover a {
  color: #fff !important;
}

.preferences_menulinkdarkSelected__zN0Tf {
  background-color: #1c2e45;
  color: #3b82f6;
}

.preferences_menuthemelight__FTSff .preferences_menulinklightSelected__reWhp {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #0f4d0f;
}

.preferences_menuthemelight__FTSff .preferences_menulinklightSelected__reWhp svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.preferences_menulinkdark__YRAx\\+ {
  color: #92afd3 !important;
}

.preferences_menulinklight__3Lqd7:hover {
  color: #fff !important;
  background-color: #0f4d0f;
}

.preferences_menulinklight__3Lqd7:hover svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.preferences_menulinklight__3Lqd7 .preferences_sub_arrow__K5P8y svg path {
  stroke: #cbcbcb !important;
}

.preferences_menulinklight__3Lqd7:hover .preferences_sub_arrow__K5P8y svg path {
  stroke: #fff !important;
}

.preferences_menulinkdark__YRAx\\+ .preferences_sub_arrow__K5P8y svg path {
  stroke: #92afd3 !important;
}

.preferences_menulinkdark__YRAx\\+:hover .preferences_sub_arrow__K5P8y svg path {
  stroke: #fff !important;
}

.preferences_menulinkdark__YRAx\\+:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.preferences_headinglight__x4dYo {
  color: #60677e;
}

.preferences_headingdark__RPbE2 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.preferences_searchboxlight__ijq4Y {
  background-color: #fff;
  border: none;
}

.preferences_searchboxdark__sEMKE {
  background-color: #132337;
  color: #fff;
  border: none;
}

.preferences_searchboxdark__sEMKE::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.preferences_tableheadlight__XPJQ4 {
  background-color: #131f43;
  border-radius: 5px 5px 0px 0px;
}

.preferences_tableheadlight__XPJQ4 th {
  color: #fff;
  background-color: #0f4d0f;
}

thead .preferences_tableheadlight__XPJQ4 th:first-child,
thead .preferences_tableheaddark__\\+2rDh th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .preferences_tableheadlight__XPJQ4 th:last-child,
thead .preferences_tableheaddark__\\+2rDh th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.preferences_table__BP\\+02.preferences_table-borderless__H7cIg {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.preferences_tableheaddark__\\+2rDh {
  background-color: #132337;
  color: #fff;
}

.preferences_table-borderless__H7cIg tr:nth-child(even) {
  background-color: #f9fafb;
}

.preferences_table-borderless__H7cIg .preferences_left-section__6ls-q {
  padding-top: 10px;
}

.preferences_tablebodylight__FAGxy td,
.preferences_tablebodydark__JAnvR td {
  padding: 0.5rem 1rem !important;
  line-height: 30px;
}

.preferences_tablebodylight__FAGxy {
  background-color: #fff;
}
.preferences_tablebodylight__FAGxy:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.preferences_tablebodydark__JAnvR {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.preferences_tablebodydark__JAnvR:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.preferences_paginationlight__5Hjsu {
  color: #60677e !important;
  font-size: 13px !important;
}

.preferences_paginationdark__lu5oV {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.preferences_formthemelight__q3vTO {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.preferences_formthemedark__I1pqo {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.preferences_formthemedark__I1pqo ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.preferences_viewformlight__4yKMt {
  background-color: #f3f6f9;
}

.preferences_permissionboxlight__6lfep {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.preferences_permissionboxdark__gGSCa {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.preferences_errormsgclr__zz3-Z {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.preferences_graphclrlight__IKRVf {
  background-color: #fff;
}

.preferences_graphclrdark__kBaaI {
  background-color: #132337;
}

/* 
Counter theme
*/
#preferences_card1bglight__tjy3Q {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#preferences_card1bgdark__bXNWZ {
  background: #392f28;
}

#preferences_card2bglight__5jhHk {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#preferences_card2bgdark__jXDR9 {
  background: #1c3238;
}

#preferences_card3bglight__33Qkg {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#preferences_card3bgdark__AryWb {
  background: #3a2434;
}

#preferences_card4bglight__JHMsk {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#preferences_card4bgdark__eweA0 {
  background: #2f264f;
}

#preferences_card1bgdark__bXNWZ a,
#preferences_card1bgdark__bXNWZ p,
#preferences_card2bgdark__jXDR9 a,
#preferences_card2bgdark__jXDR9 p,
#preferences_card3bgdark__AryWb a,
#preferences_card3bgdark__AryWb p,
#preferences_card4bgdark__eweA0 a,
#preferences_card4bgdark__eweA0 p {
  color: #fff;
}

/* 
Action button theme
*/
.preferences_actionbtnlight__HDnp3 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.preferences_actionbtnlight__HDnp3:hover {
  cursor: pointer;
}

.preferences_actionbtndark__Ao-sf {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.preferences_profiledropdownlight__-DJRK {
  background-color: #fff;
}

.preferences_profiledropdowndark__Gx3xT {
  background-color: #151521;
}

.preferences_settingsection__w4Ex8 #preferences_addform__oGG7x.preferences_formthemedark__I1pqo .preferences_savebtn__NIyFf {
  background-color: #3b82f6;
  color: #fff;
}

#preferences_addform__oGG7x.preferences_formthemedark__I1pqo .preferences_savebtn__NIyFf {
  background-color: #3b82f6;
  color: #fff;
}

.preferences_profile_conatiner__4LKOk {
  border-radius: 5px !important;
}

.preferences_bodythemedark__np6Ve .preferences_ag-theme-alpine__F37Wi .preferences_ag-row__BQWoB {
  background: #000 !important;
}

.preferences_bodythemedark__np6Ve .preferences_formbtn__MYlvp {
  background-color: #3b82f6;
}

.preferences_bodythemedark__np6Ve .preferences_formbtn__MYlvp:hover {
  background-color: #2563eb;
}

.preferences_bodythemedark__np6Ve .preferences_resetbtn__GAT1d {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.preferences_bodythemedark__np6Ve .preferences_resetbtn__GAT1d:hover {
  background-color: #3b82f6;
}

.preferences_headingdark__RPbE2 span {
  background-color: #132337;
}

.preferences_resetbtn__GAT1d {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  min-width: 113px;
}

.preferences_resetbtn__GAT1d:hover,
.preferences_resetbtn__GAT1d:active,
.preferences_resetbtn__GAT1d:focus {
  background-color: #131f43;
  color: #fff;
}

.preferences_addBtn__DeCdD {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38a169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.preferences_addbtnlight__iFnf- {
  background-color: #38a169;
}

.preferences_addbtndark__-Qnu6 {
  background-color: #3b82f6;
}

.preferences_addbtndark__-Qnu6:hover {
  background-color: #2563eb;
}

.preferences_formthemedark__I1pqo label {
  color: #92afd3;
}

.preferences_addBtn__DeCdD svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.preferences_addBtn__DeCdD:hover {
  color: #fff;
  background-color: #38a169;
  border: none;
}

.preferences_cust_addBtn__7UZXY.preferences_addBtn__DeCdD svg {
  top: 2px;
}

.preferences_deleteBtn__9qyD7 {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.preferences_deleteBtn__9qyD7 {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.preferences_deleteBtn__9qyD7:active,
.preferences_deleteBtn__9qyD7:focus {
  background-color: #f94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.preferences_deleteBtn__9qyD7 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.preferences_deleteBtn__9qyD7:hover,
.preferences_deleteBtn__9qyD7:active,
.preferences_deleteBtn__9qyD7:focus {
  background-color: #f94747;
  color: #fff;
  border: none;
}

.preferences_confirmBtn__JDTye {
  background-color: #131f43;
}

.preferences_confirmBtn__JDTye:hover,
.preferences_confirmBtn__JDTye:active,
.preferences_confirmBtn__JDTye:focus {
  background-color: #131f43;
}

.preferences_confirmBtn__JDTye svg {
  top: 0;
}

.preferences_delPopContainer__nLae- .preferences_modal-body__SNFZQ {
  padding: 25px;
  text-align: center;
}

.preferences_delPopContainer__nLae- .preferences_delet_icon__Gec\\+n {
  margin-bottom: 11px;
}

.preferences_delPopContainer__nLae- p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.preferences_arrowback__drSNZ svg {
  fill: #000;
}

.preferences_bodythemedark__np6Ve .preferences_arrowback__drSNZ {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.preferences_bodythemedark__np6Ve .preferences_arrowback__drSNZ svg {
  fill: #3b82f6;
}

.preferences_bodythemedark__np6Ve .preferences_drpdwn_btn__sEdF1 {
  background-color: #132337;
}

.preferences_bodythemedark__np6Ve .preferences_empname__-jOgz {
  color: #92afd3 !important;
}

.preferences_bodythemedark__np6Ve .preferences_navitemli__fGQU8 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingsgeneral__D3n6U,
.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingslinks__1rthO:hover {
  background-color: #3b82f6;
  color: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingslinks__1rthO {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 {
  background-color: #1c2e45;
  color: #fff;
}

.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 ul li a,
.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 .preferences_dropdown_item__e\\+PKG,
.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 .preferences_dropdown_item__e\\+PKG h5 {
  color: #fff;
}

.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 ul li a:hover,
.preferences_headerthemedark__EFH3X .preferences_dropdown_menu_contain__oPqK0 .preferences_dropdown_item__e\\+PKG:hover {
  background-color: #132337;
  color: #fff;
}

.preferences_dropdown_item__e\\+PKG:active {
  background-color: #f5f6fa;
}

.preferences_profile_arrrow_dwn__OCBB3 {
  stroke: #132337;
}

.preferences_headerthemedark__EFH3X .preferences_profile_arrrow_dwn__OCBB3 {
  stroke: #fff;
}

.preferences_dateinputbox1__KxIIZ input,
.preferences_dateinputbox1__KxIIZ span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .preferences_tableheadlight__XPJQ4 th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .preferences_dashboard__tSBy1 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .preferences_cont2__depn9 {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (min-width: 767px) {
  .preferences_messageminwidth__nGpJS {
    white-space: normal;
    word-wrap: break-word;
    width: 37%;
  }
}
@media only screen and (max-width: 767px) {
  td {
    max-width: 700px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .preferences_messageminwidth__nGpJS {
    white-space: nowrap;
    word-wrap: break-word;
  }
  .preferences_sectionright__lDN5V {
    float: unset !important;
  }
  .preferences_dashboard__tSBy1 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .preferences_cont2__depn9 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
    overflow-x: inherit !important;
  }
  .preferences_bodythemelight__tHR-R,
  .preferences_bodythemedark__np6Ve {
    padding-top: 83px;
  }
  .preferences_top_header__l7aPN {
    min-height: 69px;
  }
}
@media (min-width: 576px) {
  .preferences_exer_modal_contain__lNxkM .preferences_modal-dialog__AU0YP {
    max-width: 1055px;
  }
  .preferences_delPopContainer__nLae- .preferences_modal-dialog__AU0YP {
    max-width: 350px;
  }
}
#preferences_addform__oGG7x {
  margin-top: 30px;
  padding: 30px;
  border-radius: 10px;
}
#preferences_addform__oGG7x #preferences_addheading__v4xT9 {
  font-size: 16px;
  margin-bottom: 20px;
}
#preferences_addform__oGG7x .preferences_selectdate__Qx0TG {
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  height: 50px;
}
#preferences_addform__oGG7x .preferences_savebtn__NIyFf {
  border: none;
  border-radius: 5px;
  background-color: #131f43;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  margin-top: 20px;
}

.preferences_date_format__F45K3 {
  display: block;
  font-weight: 600;
  font-size: 14px !important;
  margin-bottom: 12px !important;
  color: #727272;
}

.preferences_formthemedark__I1pqo .preferences_date_format__F45K3 {
  color: #92afd3;
}

@media only screen and (max-width: 767px) {
  .preferences_selectdate__Qx0TG {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/preferences.module.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;ACAF;;ADGA;;EAAA;AAgDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AAQA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAvFO;EAwFP,2BAAA;EACA,gBAAA;ACrEF;;ADuEA;EACE,yBAAA;EACA,yBA7FO;EA8FP,kBAAA;ACpEF;;ADsEA;;;EAGE,yBAjEmB;ACFrB;;ADqEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AClEF;;ADqEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBArHO;EAsHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;AChEF;;ADsEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACnEF;;ADsEA;EACE,YAAA;ACnEF;;ADsEA;EACE,sBA9FY;AC2Bd;;ADsEA;;CAAA;AAGA;EACE,sBArGY;EAsGZ,iBAAA;ACnEF;;ADqEA;EACE,yBApHe;EAqHf,iBAAA;AClEF;;ADqEA;;CAAA;AAGA;EACE,sBAjHY;AC+Cd;;ADqEA;EACE,yBAhIe;AC8DjB;;ADoEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACjEF;;ADoEA;;CAAA;AAGA;EACE,sBArIY;ACoEd;;ADmEA;EACE,yBAnJe;ACmFjB;;ADmEA;;CAAA;AAGA;EACE,yBAAA;AChEF;;ADmEA;EACE,yBAAA;AChEF;;ADmEA;;EAEE,sBAAA;AChEF;;ADmEA;EACE,yBArKqB;EAsKrB,cA9KiB;AC8GnB;;ADkEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAAA;AC/DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,yBAnNqB;EAoNrB,WA3MY;AC6Id;;ADiEA;;CAAA;AAGA;EACE,cA/Me;ACiJjB;;ADiEA;EACE,cAnNe;ACqJjB;;ADiEA;;CAAA;AAGA;EACE,sBA7NY;EA8NZ,YAAA;AC9DF;;ADiEA;EACE,yBA7Oe;EA8Of,WAnOY;EAoOZ,YAAA;AC9DF;;ADgEA;EACE,cApOe;ACuKjB;;ADgEA;;CAAA;AAGA;EACE,yBAzRc;EA0Rd,8BAAA;AC7DF;;AD+DA;EACE,WAlPY;EAmPZ,yBAAA;AC5DF;;AD8DA;;EAEE,0BAAA;AC3DF;;AD6DA;;EAEE,0BAAA;AC1DF;;AD4DA;EACE,kBAAA;ACzDF;;AD2DA;EACE,kBAAA;ACxDF;;AD0DA;EACE,oCAAA;EACA,gCAAA;ACvDF;;AD0DA;EACE,yBAjQkB;EAkQlB,WA1QY;ACmNd;;ADyDA;EACE,yBAAA;ACtDF;;ADwDA;EACE,iBAAA;ACrDF;;ADuDA;;EAEE,+BAAA;EACA,iBAAA;ACpDF;;ADsDA;EACE,sBAxRY;ACqOd;ADqDE;EACE,yBAAA;EACA,YAAA;ACnDJ;;ADsDA;EACE,0CAAA;EACA,cA9Re;AC2OjB;ADqDE;EACE,yCAAA;EACA,YAAA;ACnDJ;;ADuDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;ACpDF;;ADsDA;EACE,yBAAA;EACA,0BAAA;ACnDF;;ADsDA;;CAAA;AAGA;EACE,sBAzTY;EA0TZ,yBAAA;EACA,qDAAA;ACnDF;;ADqDA;EACE,yBAtTkB;EAuTlB,yBAAA;EACA,eAAA;AClDF;ADoDE;EACE,cAhUa;AC8QjB;;ADsDA;;CAAA;AAGA;EACE,yBA9UgB;AC2RlB;;ADsDA;EACE,yBAAA;EACA,yBAAA;ACnDF;;ADqDA;EACE,yBA7VmB;EA8VnB,yBAAA;AClDF;;ADqDA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AClDF;;ADqDA;;CAAA;AAGA;EACE,sBAjWY;AC+Sd;;ADqDA;EACE,yBA7VkB;AC2SpB;;ADqDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA7WY;AC2Td;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAtXY;ACoUd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBA/XY;AC6Ud;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAxYY;ACsVd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;;;;;;;;EAQE,WAvZY;ACqWd;;ADqDA;;CAAA;AAGA;EACE,qCAAA;AClDF;;ADoDA;EACE,eAAA;ACjDF;;ADmDA;EACE,cAjae;ACiXjB;;ADmDA;;CAAA;AAGA;EACE,sBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAlciB;EAmcjB,WApbY;ACoYd;;ADkDA;EACE,yBAtciB;EAucjB,WAxbY;ACyYd;;ADkDA;EACE,6BAAA;AC/CF;;ADkDA;EACE,2BAAA;AC/CF;;ADkDA;EACE,yBAndiB;ACoanB;;ADkDA;EACE,yBAtduB;ACuazB;;ADkDA;EACE,WA5cY;EA6cZ,6BAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE,yBAjeiB;ACkbnB;;ADkDA;EACE,yBAjee;ACkbjB;;ADkDA;EACE,eAAA;EACA,gBA5gBc;EA6gBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA1gBc;EA2gBd,gBAAA;AC/CF;;ADiDA;;;EAGE,yBAhhBc;EAihBd,WAteY;ACwbd;;ADiDA;EACE,gBAAA;EACA,YAAA;EACA,WA5eY;EA6eZ,yBAtgBY;EAugBZ,YAAA;EACA,eAAA;EACA,gBAjiBc;ACmfhB;;ADiDA;EACE,yBA7gBY;AC+dd;;ADgDA;EACE,yBAtgBiB;ACydnB;;AD+CA;EACE,yBAxgBuB;AC4dzB;;AD+CA;EACE,cA9gBgB;ACkelB;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AC5CF;;AD+CA;EACE,WAxgBY;EAygBZ,yBAliBY;EAmiBZ,YAAA;AC5CF;;AD+CA;EACE,QAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAtiBU;EAuiBV,WArhBY;EAshBZ,eAAA;EACA,gBAxkBc;EAykBd,YAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAhjBU;EAijBV,WA/hBY;EAgiBZ,eAAA;EACA,gBAllBc;EAmlBd,YAAA;AC5CF;;AD+CA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;AC5CF;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AC5CF;;AD+CA;;;EAGE,yBAvkBU;EAwkBV,WAtjBY;EAujBZ,YAAA;AC5CF;;AD+CA;EACE,yBAtmBc;AC0jBhB;;AD+CA;;;EAGE,yBA5mBc;ACgkBhB;;AD+CA;EACE,MAAA;AC5CF;;AD+CA;EACE,aAAA;EACA,kBAAA;AC5CF;;AD+CA;EACE,mBAAA;AC5CF;;AD+CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC5CF;;AD+CA;EACE,UAAA;AC5CF;;AD+CA;EACE,yCAzmBa;EA0mBb,cA9mBiB;ACkkBnB;;AD+CA;EACE,aAlnBiB;ACskBnB;;AD+CA;EACE,yBAhnBe;ACokBjB;;AD+CA;EACE,yBAAA;AC5CF;;AD+CA;EACE,6BAAA;EACA,yBAAA;EACA,WA/mBY;ACmkBd;;AD+CA;;EAEE,yBAnoBiB;EAooBjB,WArnBY;ACykBd;;AD8CA;EACE,6BAAA;EACA,yBAAA;EACA,WA1nBY;AC+kBd;;AD8CA;EACE,yBAvoBqB;EAwoBrB,WA/nBY;AColBd;;AD8CA;;;EAGE,WAroBY;AC0lBd;;AD8CA;;EAEE,yBArpBe;EAspBf,WA3oBY;ACgmBd;;AD8CA;EACE,yBA3rBO;ACgpBT;;AD8CA;EACE,eA9pBe;ACmnBjB;;AD8CA;EACE,YAvpBY;AC4mBd;;AD8CA;;EAEE,sBAAA;AC3CF;;AD8CA,iBAAA;AAOA;EACE;IACE,gBAAA;ECjDF;AACF;ADmDA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECjDF;EDmDA;IACE,2BAAA;IACA,gBAAA;ECjDF;AACF;ADmDA;EACE;;IAAA;AC/CF;ADmDA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ECjDF;AACF;ADoDA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EClDF;EDoDA;IACE,mBAAA;IACA,qBAAA;EClDF;EDoDA;IACE,uBAAA;EClDF;EDoDA;IACE,6BAAA;EClDF;AACF;ADoDA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;ECnDF;EDqDA;;IAEE,iBAAA;ECnDF;EDqDA;IACE,gBAAA;ECnDF;AACF;ADsDA;EACE;IACE,iBAAA;ECpDF;EDsDA;IACE,gBAAA;ECpDF;AACF;AAnvBA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAqvBJ;AAnvBQ;EACI,eAAA;EACA,mBAAA;AAqvBZ;AAlvBQ;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAovBZ;AAhvBQ;EACI,YAAA;EACA,kBAAA;EACA,yBDkDO;ECjDP,aAAA;EACA,WDmCE;EClCF,eAAA;EACA,gBAAA;AAkvBZ;;AA9uBA;EACI,cAAA;EACA,gBDtBY;ECuBZ,0BAAA;EACA,8BAAA;EACA,cDjBa;ACkwBjB;;AA9uBA;EACI,cDIc;AC6uBlB;;AA9uBA;EACI;IACI,WAAA;EAivBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #f5f6fa;\n$primary-color: #131f43;\n$icon-bgcolor: #f6f6f6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #f3f4f8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #faf4fb;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #faf7f3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #f5f9fc;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #ac44bb;\n$cardIcon3-color: #d69a5f;\n$cardIcon4-color: #176ca5;\n$green-color: #38a169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading: #0b0d0f;\n$light-gray: #999999;\n$menu_icon: #cbcbcb;\n$red-color: #f94747;\n$dark-active-blue: #3b82f6;\n$dark-light-blue: #92afd3;\n$addBtn-dark-blue: #3b82f6;\n$addBtn-dark-blue-hover: #2563eb;\n$backBtn-dark: #3b82f633;\n\n$darkTheme_blue: #132337;\n$darkTheme_darkBlue: #0f1824;\n$darkTheme_selectBlue: #1c2e45;\n$darkTheme_updateBtn: #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131f43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: 35px 35px;\n  border-radius: 0px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-color: $mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n.menuthemelight .menulinklightSelected svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n\n.menulinklight:hover svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n  background-color: #0f4d0f;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n}\ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 30px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover {\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color: $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n}\n\n.modalStyleDark {\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (min-width: 767px) {\n  .messageminwidth {\n    white-space: normal;\n    word-wrap: break-word;\n    width: 37%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  td {\n    max-width: 700px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .messageminwidth {\n    white-space: nowrap;\n    word-wrap: break-word;\n  }\n  .sectionright {\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n \n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n    overflow-x: inherit !important;\n  }\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 83px;\n  }\n  .top_header {\n    min-height: 69px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n#addform{\n    margin-top: 30px;\n    padding: 30px;\n    border-radius: 10px;\n\n        #addheading{\n            font-size: 16px;\n            margin-bottom: 20px;\n        }\n\n        .selectdate{\n            padding: 5px;\n            border: 1px solid #ced4da;\n            border-radius: 5px;\n            height: 50px;\n        }\n\n        \n        .savebtn{\n            border: none;\n            border-radius: 5px;\n            background-color: $primary-btncolor;\n            padding: 10px;\n            color: $white-color;\n            font-size: 14px;\n            margin-top: 20px;\n        }\n}\n\n.date_format {\n    display: block;\n    font-weight: $font-semiBold;\n    font-size: 14px !important;\n    margin-bottom: 12px !important; \n    color: $text-graycolor;\n}\n\n.formthemedark .date_format { \n    color: $dark-light-blue;\n}\n\n@media only screen and (max-width: 767px) {\n    .selectdate{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `preferences_dashboard__tSBy1`,
	"dashboardContain": `preferences_dashboardContain__bDkZ5`,
	"bodythemedark": `preferences_bodythemedark__np6Ve`,
	"cont2": `preferences_cont2__depn9`,
	"top_header": `preferences_top_header__l7aPN`,
	"top_header_inner": `preferences_top_header_inner__Dth2I`,
	"subLink": `preferences_subLink__khKDa`,
	"footer": `preferences_footer__r04q2`,
	"bodythemelight": `preferences_bodythemelight__tHR-R`,
	"headerthemelight": `preferences_headerthemelight__Hco8q`,
	"headerthemedark": `preferences_headerthemedark__EFH3X`,
	"menuthemelight": `preferences_menuthemelight__FTSff`,
	"menuthemedark": `preferences_menuthemedark__Qijid`,
	"menulinklight": `preferences_menulinklight__3Lqd7`,
	"menulinkdarkSelected": `preferences_menulinkdarkSelected__zN0Tf`,
	"menulinklightSelected": `preferences_menulinklightSelected__reWhp`,
	"menulinkdark": `preferences_menulinkdark__YRAx+`,
	"sub_arrow": `preferences_sub_arrow__K5P8y`,
	"headinglight": `preferences_headinglight__x4dYo`,
	"headingdark": `preferences_headingdark__RPbE2`,
	"searchboxlight": `preferences_searchboxlight__ijq4Y`,
	"searchboxdark": `preferences_searchboxdark__sEMKE`,
	"tableheadlight": `preferences_tableheadlight__XPJQ4`,
	"tableheaddark": `preferences_tableheaddark__+2rDh`,
	"table": `preferences_table__BP+02`,
	"table-borderless": `preferences_table-borderless__H7cIg`,
	"left-section": `preferences_left-section__6ls-q`,
	"tablebodylight": `preferences_tablebodylight__FAGxy`,
	"tablebodydark": `preferences_tablebodydark__JAnvR`,
	"paginationlight": `preferences_paginationlight__5Hjsu`,
	"paginationdark": `preferences_paginationdark__lu5oV`,
	"formthemelight": `preferences_formthemelight__q3vTO`,
	"formthemedark": `preferences_formthemedark__I1pqo`,
	"viewformlight": `preferences_viewformlight__4yKMt`,
	"permissionboxlight": `preferences_permissionboxlight__6lfep`,
	"permissionboxdark": `preferences_permissionboxdark__gGSCa`,
	"errormsgclr": `preferences_errormsgclr__zz3-Z`,
	"graphclrlight": `preferences_graphclrlight__IKRVf`,
	"graphclrdark": `preferences_graphclrdark__kBaaI`,
	"card1bglight": `preferences_card1bglight__tjy3Q`,
	"card1bgdark": `preferences_card1bgdark__bXNWZ`,
	"card2bglight": `preferences_card2bglight__5jhHk`,
	"card2bgdark": `preferences_card2bgdark__jXDR9`,
	"card3bglight": `preferences_card3bglight__33Qkg`,
	"card3bgdark": `preferences_card3bgdark__AryWb`,
	"card4bglight": `preferences_card4bglight__JHMsk`,
	"card4bgdark": `preferences_card4bgdark__eweA0`,
	"actionbtnlight": `preferences_actionbtnlight__HDnp3`,
	"actionbtndark": `preferences_actionbtndark__Ao-sf`,
	"profiledropdownlight": `preferences_profiledropdownlight__-DJRK`,
	"profiledropdowndark": `preferences_profiledropdowndark__Gx3xT`,
	"settingsection": `preferences_settingsection__w4Ex8`,
	"addform": `preferences_addform__oGG7x`,
	"savebtn": `preferences_savebtn__NIyFf`,
	"profile_conatiner": `preferences_profile_conatiner__4LKOk`,
	"ag-theme-alpine": `preferences_ag-theme-alpine__F37Wi`,
	"ag-row": `preferences_ag-row__BQWoB`,
	"formbtn": `preferences_formbtn__MYlvp`,
	"resetbtn": `preferences_resetbtn__GAT1d`,
	"addBtn": `preferences_addBtn__DeCdD`,
	"addbtnlight": `preferences_addbtnlight__iFnf-`,
	"addbtndark": `preferences_addbtndark__-Qnu6`,
	"cust_addBtn": `preferences_cust_addBtn__7UZXY`,
	"deleteBtn": `preferences_deleteBtn__9qyD7`,
	"confirmBtn": `preferences_confirmBtn__JDTye`,
	"delPopContainer": `preferences_delPopContainer__nLae-`,
	"modal-body": `preferences_modal-body__SNFZQ`,
	"delet_icon": `preferences_delet_icon__Gec+n`,
	"arrowback": `preferences_arrowback__drSNZ`,
	"drpdwn_btn": `preferences_drpdwn_btn__sEdF1`,
	"empname": `preferences_empname__-jOgz`,
	"navitemli": `preferences_navitemli__fGQU8`,
	"tabnavli": `preferences_tabnavli__H0hVT`,
	"settingsgeneral": `preferences_settingsgeneral__D3n6U`,
	"settingslinks": `preferences_settingslinks__1rthO`,
	"dropdown_menu_contain": `preferences_dropdown_menu_contain__oPqK0`,
	"dropdown_item": `preferences_dropdown_item__e+PKG`,
	"profile_arrrow_dwn": `preferences_profile_arrrow_dwn__OCBB3`,
	"dateinputbox1": `preferences_dateinputbox1__KxIIZ`,
	"messageminwidth": `preferences_messageminwidth__nGpJS`,
	"sectionright": `preferences_sectionright__lDN5V`,
	"exer_modal_contain": `preferences_exer_modal_contain__lNxkM`,
	"modal-dialog": `preferences_modal-dialog__AU0YP`,
	"addheading": `preferences_addheading__v4xT9`,
	"selectdate": `preferences_selectdate__Qx0TG`,
	"date_format": `preferences_date_format__F45K3`
};
export default ___CSS_LOADER_EXPORT___;
